import { useEffect } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import TableWidget from "../../../components/tables/TableWidget";
import { getHistoryCutiePicking } from "../../../redux/api/inventory.api";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { clearPickingBoxes } from "../../../redux/reducer/inventory.reducer";
import {
  pickingBoxHistoryTableHeader,
  getPickingBoxHistoryTableData,
} from "./tableConfigs/pickingBoxHistoryTableConfig";
import { PickingBoxHistoryResponseInterface } from "../../../redux/interfaces/inventory.interface";

export default function PickingBoxHistory() {
  const { id } = useParams<{ id: string }>();
  const [searchParams] = useSearchParams();
  const nameFromList = searchParams.get("numeCutie") ?? "";
  const dispatch = useAppDispatch();
  const response = useAppSelector(
    (state) => state.inventory.pickingBoxes.history,
  );

  const history = response.data as PickingBoxHistoryResponseInterface | null;
  const boxName = history?.data.cutie.nume ?? nameFromList;

  useEffect(() => {
    if (id) dispatch(getHistoryCutiePicking(id));
    return () => {
      dispatch(clearPickingBoxes());
    };
  }, [dispatch, id]);

  return (
    <>
      <TableWidget
        tableTitle={`Istoric cutie${boxName ? ` ${boxName}` : ""}`}
        tableHeaderData={pickingBoxHistoryTableHeader}
        tableItemsData={getPickingBoxHistoryTableData(
          history?.data.istoric ?? [],
        )}
        tableLoading={response.status === "loading"}
        withTablePagination={false}
        withGlobalSearch={false}
        withGlobalFilter={false}
        showSearchForCategories={false}
        emptyTableLabel={"Nu exista istoric"}
      />
    </>
  );
}
